import { Box } from "@mui/system";
import { Grid } from "@mui/material";
import { toast } from "react-toastify";
import { useRecoilValue } from "recoil";
import { useLocation } from "react-router";
import { useEffect, useState } from "react";
import { configState } from "../../../../../recoil/atoms";
import { InputField, SelectField } from "../../../../../utils/FormFields";
import { CurrencyApi, CurrencyResponse, GetCurrencyResponseCurrencies } from "../../../../../api/payment";
import AutocompletePatient from "../../../../MedicalOperations/Appointments/FormFields/AutocompletePatient";

type Props = {
  isEditing: boolean;
};

const ReceiptForm = ({isEditing}: Props) => {
  const { pathname }  = useLocation();
  const config = useRecoilValue(configState);
  const isGeneralReceipt = pathname.includes("payment");

  const [currency, setCurrency] = useState<GetCurrencyResponseCurrencies[]>([]);

  const getCurrency = () => {
    const Currency = new CurrencyApi(config);
    Currency.getCurrency()
      .then((res) => {
        setCurrency(res?.data?.currencies!);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  useEffect(() => {
    getCurrency();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const availableCurrency = currency?.map((item: CurrencyResponse) => {
    return {
      label: item.name,
      value: item.currency_id,
    };
  });

  return (
    <>
      <Box
        sx={{
          py: 4.5,
          bgcolor: "#e7e3ff",
          color: "grey.800",
          borderRadius: "16px",
        }}
      >
        <Grid
          container
          rowSpacing={6}
          spacing={2}
          sx={{ p: 1, pt: 2, justifyContent: "center", alignContent: "center" }}
        >
          {isGeneralReceipt && !isEditing && (
            <Grid item xs={12} sm={6}>
              <AutocompletePatient name="patient_id" />
            </Grid>
          )}
          <Grid container />
          <Grid item xs={12} sm={3} sx={{ mb: 3 }}>
            <InputField name="amount" label="Amount Fee" type="number" fullWidth />
          </Grid>

          <Grid item xs={12} sm={3} sx={{ mb: 3 }}>
            <SelectField name="currency" label="Currency (USD by default)" data={availableCurrency} fullWidth />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ReceiptForm;
